"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = transition;
function transition(seconds) {
  return "\n    -webkit-transition: all ".concat(seconds, "s ease-in-out;\n    transition: all ").concat(seconds, "s ease-in-out;\n  ");
}